'use client'

import { Box, styled } from '@mui/material'
import { createBlueStyles } from '@biolumina/ui/components/button/button.styles'

export const StyledNavMenu = styled(Box)(({ theme }) => {
  const activeLinkStyles = {
    fontWeight: 800,
    borderBottom: `2px solid ${theme.palette.tertiary.main}`,
    padding: theme.spacing(0, 1)
  }
  return {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
	  
	
    'a.nav-link': {
      'svg + .MuiTouchRipple-root + svg, svg + svg': {
        display: 'none',
      },
      '&:not(.blue)': {
        color: theme.palette.primary.main,
        height: '36px',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        lineHeight: 1,
        fontWeight: 500,
        margin: theme.spacing(1, 0),
        padding: theme.spacing(0, 1.25),
        //margin: '4px 0',
        textDecoration: 'none',
        position: 'relative',
        boxSizing: 'border-box',
        zIndex: 2,
        span: {
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          svg: {
            stroke: 'currentColor',
            strokeWidth: 1.5,
          },
        },
        borderBottom: `2px solid transparent`,
        '&.active, &:hover': {
          ...activeLinkStyles,
        },
        [theme.breakpoints.up('md')]: {
          fontSize: '.8rem',
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: '1rem',
          //padding: theme.spacing(1, 1.5),
          whiteSpace: 'nowrap',
        },
        [theme.breakpoints.up('xl')]: {
          //padding: theme.spacing(0, 3),
        },
      },
      '&.blue': {
        ...createBlueStyles(theme),
      }
    },

    '&:hover': {
      zIndex: 19,
      'a.nav-link:not(.blue)': {
        ...activeLinkStyles,
        '&.hasChildren::after': {
          content: '" "',
          position: 'absolute',
          top: '100%',
          left: '0',
          width: '100%',
          height: '15px',
          backgroundColor: 'transparent',
        },
      },
    },
	 


    '.sub-nav-container': {
      position: 'fixed',
      left: 0,
      width: '100%',
      backgroundColor: theme.palette.secondary.main,
      boxSizing: 'border-box',
      padding: theme.spacing(2, 10),
      zIndex: 2,
      '&.persist': {
        display: 'block',
        zIndex: 1
      },
      '.sub-nav': {
        alignItems: 'center',
        //justifyContent: 'center',
        width: '100%',
        height: '100%',
        maxWidth: '900px',
        margin: '0 auto',
        //display: 'none',
		  
		
        '.sub-nav-link': {
          color: theme.palette.primary.main,
          lineHeight: 1.22,
          //marginBottom: theme.spacing(1),
          textDecoration: 'none',
          textAlign: 'center',
          fontWeight: theme.typography.fontWeightRegular,
          '&:hover, &.active, &.active-scroll-spy': {
            fontWeight: theme.typography.fontWeightBold,
          },
        },
      },
    },
  }
})
